module.exports = __webpack_public_path__ + "img/buy-icon7.d944732.png";